import React from "react";
import { Link } from "react-router-dom";
import { LayoutLegal } from "../components/shared/LayoutLegal";

export const Privacy = () => {
  return (
    <LayoutLegal>
      <h1>Política de Privacidad</h1>

      <h2>1. Información general</h2>
      <p>
        En <strong>Beyond the Code</strong> (en adelante, "nosotros" o "nuestro
        sitio web"), nos comprometemos a proteger tu privacidad y garantizar la
        seguridad de los datos personales que nos proporcionas. Esta Política de
        Privacidad describe cómo recopilamos, usamos y protegemos tu información
        personal.
      </p>

      <h2>2. Responsable del tratamiento</h2>
      <p>
        <strong>Responsable:</strong> SC Beyond the Code SRL
        <br />
        <strong>Domicilio:</strong> Arad, Romania
        <br />
        <strong>Correo electrónico de contacto:</strong>{" "}
        <a href="mailto:info@beyondthecode.es">info@beyondthecode.es</a>
        <br />
        <strong>Sitio web:</strong>{" "}
        <Link to="https://www.beyondthecode.es" target="_blank">
          www.beyondthecode.es
        </Link>
      </p>

      <h2>3. Datos que recopilamos</h2>
      <ul>
        <li>Nombre y apellidos</li>
        <li>Correo electrónico</li>
        <li>Número de teléfono</li>
        <li>País</li>
        <li>Datos de navegación (mediante cookies)</li>
      </ul>

      <h2>4. Finalidad del tratamiento</h2>
      <p>Los datos personales se recopilan con las siguientes finalidades:</p>
      <ul>
        <li>
          Procesar tu solicitud de inscripción o información sobre el bootcamp
        </li>
        <li>Enviarte comunicaciones relacionadas con el curso o promociones</li>
        <li>Mejorar la experiencia del usuario en nuestro sitio web</li>
        <li>Cumplir con obligaciones legales</li>
      </ul>

      <h2>5. Base legal para el tratamiento</h2>
      <p>
        La base legal para el tratamiento de tus datos es tu consentimiento
        expreso, que otorgas al rellenar nuestros formularios o aceptar nuestras
        cookies, así como la ejecución de un contrato en caso de que te
        inscribas en alguno de nuestros cursos.
      </p>

      <h2>6. Conservación de los datos</h2>
      <p>
        Tus datos se conservarán durante el tiempo necesario para cumplir con la
        finalidad para la que fueron recabados, y posteriormente durante los
        plazos legales exigidos.
      </p>

      <h2>7. Compartición de datos</h2>
      <p>
        No compartimos tus datos con terceros, salvo obligación legal o si es
        estrictamente necesario para la prestación del servicio (por ejemplo,
        plataformas de pago o herramientas de email marketing).
      </p>

      <h2>8. Derechos del usuario</h2>
      <p>Tienes derecho a:</p>
      <ul>
        <li>Solicitar la supresión de tus datos</li>
        <li>Oponerte al tratamiento</li>
        <li>Retirar tu consentimiento en cualquier momento</li>
      </ul>
      <p>
        Puedes ejercer estos derechos escribiéndonos a{" "}
        <a href="mailto:info@beyondthecode.es">info@beyondthecode.es</a>.
      </p>

      <h2>9. Cookies</h2>
      <p>
        Utilizamos cookies para mejorar tu experiencia de navegación. Puedes
        gestionar tus preferencias de cookies desde la configuración de tu
        navegador o nuestra
        <Link to="/cookies" target="_blank">
          {" "}
          Política de Cookies
        </Link>
        .
      </p>

      <h2>10. Modificaciones</h2>
      <p>
        Nos reservamos el derecho de modificar esta Política de Privacidad en
        cualquier momento. Cualquier cambio será publicado en esta misma página.
      </p>
    </LayoutLegal>
  );
};
